import { createContext } from 'react';
const PaymentsEmbedPointContext = /*#__PURE__*/createContext({
  getPaymentsInterstitialModalOpenHandler: () => () => {}
});
PaymentsEmbedPointContext.displayName = 'PaymentsEmbedPointContext';
export default PaymentsEmbedPointContext;